import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 400px)
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-431">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-background border-t border-surface shadow-[0_-4px_20px_rgba(0,0,0,0.05)] p-4 md:hidden" data-id="element-432">
          <motion.button whileTap={{
        scale: 0.98
      }} onClick={() => {
        window.location.href = 'https://valordigital.store/cart/46518849142973:1';
      }} className="w-full bg-primary hover:bg-primary-hover text-white font-bold uppercase tracking-wider py-3.5 px-6 rounded-xl shadow-soft transition-colors text-sm flex items-center justify-center gap-2" data-id="element-433">
            Descargar ahora — 50% OFF
          </motion.button>
        </motion.div>}
    </AnimatePresence>;
}